import axios from 'axios'

import { DocumentTypes, DraftInterface } from '../Interfaces/Draft/DraftInterface'
import { EstimateInterface, InvoiceInterface } from '../Interfaces/Invoice/InvoiceInterface'
import { getDocument } from './document'
import { getRequestConfig } from './index'

export function downloadXrechnungUrl(id: number, type: DocumentTypes, revision: number = null) {
  return `/rest-invoice/api/${type}s/${id}/${revision != null ? revision + '/' : ''}xrechnung`
}

export function archivedDocumentUrl(id: number, revision: number, type: DocumentTypes) {
  return `/rest-invoice/api/${type}s/${id}/${type === DocumentTypes.INVOICE ? revision + '/' : ''}pdf?token=${sessionStorage.getItem('ZervantSession')}`
}

export async function deleteInvoice(id: number, documentType: DocumentTypes): Promise<number> {
  const url = `/rest-invoice/api/${documentType}s/${id}`
  const response = await axios.delete(url, getRequestConfig())
  return response.data
}

export async function saveInvoice(invoice: DraftInterface) {
  const url = `/rest-invoice/api/${invoice.document}s/${invoice.id}`
  delete invoice.id
  const response = await axios.put(url, invoice, getRequestConfig())
  return response.data
}

export async function getInvoice(id: number): Promise<InvoiceInterface | EstimateInterface> {
  const response = await getDocument(DocumentTypes.INVOICE, id)
  return response
}

export async function setStatus(id: number, documentType: DocumentTypes, statusData) {
  const url = `/rest-invoice/api/${documentType}s/${id}/status`
  return axios.post(url, statusData, getRequestConfig())
}

export async function setExternalInvoiceAsPaid(id: number, invoiceData) {
  const url = `/rest-invoice/api/v1/external/payment/${id}`
  return axios.post(url, invoiceData, getRequestConfig())
}

export async function setExternalStatusAsUnpaid(id: number) {
  const url = `/rest-invoice/api/v1/external/payment/${id}/void-payment`
  return axios.patch(url, undefined, getRequestConfig())
}
